import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Button({ children, variant = 'default', size = 'default', className = '', ...props }) {
    const variants = {
        default: 'bg-brand-600 text-white hover:bg-brand-700 shadow-sm btn-brand',
        outline: 'border border-slate-300 bg-white hover:bg-slate-50 text-slate-700',
        ghost: 'hover:bg-slate-100 text-slate-700',
        destructive: 'bg-red-600 text-white hover:bg-red-700 shadow-sm',
    };
    const sizes = { default: 'h-9 px-4 text-sm', sm: 'h-8 px-3 text-xs' };
    return _jsx("button", { className: `inline-flex items-center justify-center rounded-lg font-semibold transition-colors disabled:opacity-50 disabled:pointer-events-none ${variants[variant]} ${sizes[size]} ${className}`, ...props, children: children });
}
export function Input({ className = '', ...props }) {
    return _jsx("input", { className: `flex h-10 w-full rounded-lg border border-slate-300 bg-white px-3.5 py-2.5 text-sm text-slate-900 shadow-sm transition-colors placeholder:text-slate-400 input-field focus-visible:outline-none ${className}`, ...props });
}
export function Card({ children, className = '' }) {
    return _jsx("div", { className: `rounded-xl border border-slate-200/80 bg-white shadow-sm ${className}`, children: children });
}
export function CardHeader({ children, title }) {
    return _jsx("div", { className: "flex items-center justify-between p-5 border-b border-slate-200/80", children: title ? _jsx("h3", { className: "text-base font-semibold text-slate-900", children: title }) : children });
}
export function CardContent({ children, className = '' }) {
    return _jsx("div", { className: `p-5 ${className}`, children: children });
}
export function Badge({ children, variant = 'default', className = '' }) {
    const variants = {
        default: 'bg-slate-100 text-slate-700',
        success: 'bg-green-50 text-green-700 border-green-200',
        warning: 'bg-amber-50 text-amber-700 border-amber-200',
        danger: 'bg-red-50 text-red-700 border-red-200',
        brand: 'bg-brand-50 text-brand-700 border-brand-200',
    };
    return _jsx("span", { className: `inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold border ${variants[variant]} ${className}`, children: children });
}
export function Table({ children }) {
    return (_jsx("div", { className: "overflow-x-auto", children: _jsx("table", { className: "w-full text-sm border-collapse", children: children }) }));
}
export function THead({ children }) {
    return _jsx("thead", { className: "border-b border-slate-200 text-left text-xs uppercase tracking-wider text-slate-500 font-semibold", children: children });
}
export function TH({ children, className = '', ...props }) {
    return _jsx("th", { className: `px-5 py-3.5 font-semibold ${className}`, ...props, children: children });
}
export function TD({ children, className = '', ...props }) {
    return _jsx("td", { className: `px-5 py-3.5 border-t border-slate-100 ${className}`, ...props, children: children });
}
export function TR({ children, className = '', ...props }) {
    return _jsx("tr", { className: `hover:bg-slate-50 transition-colors ${className}`, ...props, children: children });
}
export function Select({ children, className = '', ...props }) {
    return _jsx("select", { className: `flex h-10 w-full rounded-lg border border-slate-300 bg-white px-3.5 py-2.5 text-sm shadow-sm input-field focus-visible:outline-none ${className}`, ...props, children: children });
}
export function Textarea({ className = '', ...props }) {
    return _jsx("textarea", { className: `flex w-full rounded-lg border border-slate-300 bg-white px-3.5 py-2.5 text-sm text-slate-900 shadow-sm transition-colors placeholder:text-slate-400 input-field focus-visible:outline-none ${className}`, ...props });
}
export function Dialog({ open, onClose, title, children }) {
    if (!open)
        return null;
    return (_jsxs("div", { className: "fixed inset-0 z-50 flex items-center justify-center", children: [_jsx("div", { className: "fixed inset-0 bg-black/40", onClick: onClose }), _jsxs("div", { className: "relative bg-white rounded-2xl shadow-2xl w-full max-w-lg mx-4 z-10 max-h-[90vh] overflow-y-auto", children: [_jsxs("div", { className: "flex items-center justify-between p-5 border-b border-slate-200/80", children: [_jsx("h2", { className: "text-lg font-bold text-slate-900", children: title }), _jsx("button", { onClick: onClose, className: "text-slate-400 hover:text-slate-600 text-xl leading-none", children: "\u00D7" })] }), _jsx("div", { className: "p-5", children: children })] })] }));
}
